import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.snapchatApiUrl);

export async function getSnapchatProfile({ brandId }, axiosConfig = {}) {
  return axios.get(`/brands/${brandId}/profile`, axiosConfig);
}

export async function getSnapchatProfileAllBrands({ brandIds }, axiosConfig = {}) {
  return axios.put(`/brand_profiles`, { brand_ids: brandIds }, axiosConfig);
}
